export default {
  'validation:email-is-valid': 'Vul een geldig e-mailadres in.',
  'validation:phone-is-valid': 'Je telefoonnummer lijkt niet te kloppen.',
  'validation:required': 'Vul dit in.',
  'validation:min-length-12': 'Vul minstens 12 tekens in.',
  'validation:matches-password': 'De wachtwoorden komen niet overeen.',
  'validation:zip-is-valid': 'Ongeldige postcode',
  'validation:otp-must-be-x-digits': 'De code moet precies {digits} cijfers bevatten.',
  'validation:otp-invalid-code': 'De ingevoerde code is ongeldig.',
  'validation:otp-too-many-attempts': 'Te veel pogingen. Probeer het later opnieuw.',
  'validation:otp-unknown-error': 'Er is helaas een fout opgetreden. Probeer het later opnieuw.',
  'validation:otp-guest-not-allowed': 'Gastklanten kunnen niet inloggen met een eenmalige code',
  'validation:unknown': 'Er is helaas een fout opgetreden. Probeer het later opnieuw.',
  'validation:no-whitespace': 'Spaties zijn niet toegestaan in het wachtwoord.',
};
